/* ============================================================
   ENGRAM · assets/engram-page.js — páginas Landing (ecrã 2b «Como funciona»)
   Guias em modal fora do painel de compra: sections/engram-ways desenha-os numa moldura com as classes do fluxo
   (assets/engram-flow.css): «Como escolher a fotografia» do 1n (snippets/engram-flow-photo-guide), «Como se faz o mapa»
   (snippets/engram-map-guide) e «Formas de gravar» (snippets/engram-engraving-guide). Aqui abre-se e fecha-se; no guia
   da gravação troca-se também entre as quatro formas e o detalhe de cada uma ([data-eguide-view]).
   Abre com [data-engram-guide-open="photo|map|engraving"]; fecha com ×, «Entendi», clique fora e Esc; o foco fica dentro e volta ao link.
   A página fica presa por baixo como no fluxo (body fixo + html.engram-flow-on).
   ============================================================ */
(function () {
  /* Chegar de uma página de produto com #gravacao, #mapa-das-estrelas…: o modo fica ao centro do ecrã
     (sections/engram-ways, «Anchor»). Sem script, o browser pára no modo com a folga do scroll-margin. */
  function centerWay() {
    var id = decodeURIComponent((window.location.hash || '').slice(1));
    if (!id) return;
    var way = document.getElementById(id);
    if (!way || !way.hasAttribute('data-engram-way-anchor')) return;
    way.scrollIntoView({ block: 'center' });
  }
  if (document.readyState === 'complete') centerWay();
  else window.addEventListener('load', centerWay);
  window.addEventListener('hashchange', centerWay);

  var root = document.querySelector('[data-engram-guide-modal]');
  if (!root) return;
  var dialog = root.querySelector('[data-engram-guide-dialog]');
  var guide = null;
  var opener = null;
  var scrollY = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* guia da fotografia: nesta página não há fotografia a escolher, o botão diz só «Entendi» */
  Array.prototype.forEach.call(root.querySelectorAll('[data-flow-guide="photo"] [data-flow-guide-choose]'), function (button) {
    var label = button.getAttribute('data-label-back');
    if (label) button.textContent = label;
  });

  function lockPage() {
    if (scrollY !== null) return;
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body;
    b.style.position = 'fixed'; b.style.top = -scrollY + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
  }
  function unlockPage() {
    if (scrollY === null) return;
    var b = document.body, y = scrollY;
    scrollY = null;
    b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
    window.scrollTo(0, y);
  }

  /* guia da gravação: um ecrã de cada vez — «list» (as quatro formas) ou o detalhe de uma forma */
  var eguideOpener = null;
  function showView(el, name, focusTarget) {
    if (!el) return;
    Array.prototype.forEach.call(el.querySelectorAll('[data-eguide-view]'), function (view) {
      view.hidden = view.getAttribute('data-eguide-view') !== name;
    });
    var back = el.querySelector('[data-eguide-back]');
    if (back) back.hidden = name === 'list';
    var current = el.querySelector('[data-eguide-view="' + name + '"]');
    if (current) current.scrollTop = 0;
    if (focusTarget) focusTarget.focus();
  }

  function open(name, trigger) {
    var el = root.querySelector('[data-flow-guide="' + name + '"]');
    if (!el) return;
    if (guide && guide !== el) guide.hidden = true;
    guide = el;
    opener = trigger || document.activeElement;
    /* is-guide-photo / is-guide-map: a largura e o arranjo do painel no desktop */
    dialog.className = 'engram-flow__dialog is-guide-' + name;
    root.hidden = false;
    guide.hidden = false;
    var scroller = guide.querySelector('.engram-flow__guide-body');
    if (scroller) scroller.scrollTop = 0;
    if (name === 'engraving') showView(guide, 'list');
    root.offsetWidth; /* estado inicial antes da transição */
    root.classList.add('is-open');
    document.documentElement.classList.add('engram-flow-on');
    lockPage();
    guide.focus();
  }

  function close() {
    if (root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('engram-flow-on');
    unlockPage();
    var closing = guide;
    setTimeout(function () {
      if (root.classList.contains('is-open')) return;
      root.hidden = true;
      if (closing) closing.hidden = true;
    }, 420);
    if (opener && typeof opener.focus === 'function') opener.focus();
    opener = null;
  }

  document.addEventListener('click', function (event) {
    var t = event.target && event.target.closest ? event.target : null;
    if (!t) return;
    var trigger = t.closest('[data-engram-guide-open]');
    if (trigger) { event.preventDefault(); open(trigger.getAttribute('data-engram-guide-open') || 'photo', trigger); return; }
    if (!root.contains(t)) return;
    var more = t.closest('[data-eguide-open]');
    if (more && guide) {
      eguideOpener = more;
      var way = more.getAttribute('data-eguide-open');
      showView(guide, way, guide.querySelector('[data-eguide-view="' + way + '"] [data-eguide-heading]'));
      return;
    }
    if (t.closest('[data-eguide-back]') && guide) {
      showView(guide, 'list', eguideOpener);
      eguideOpener = null;
      return;
    }
    if (t.closest('[data-flow-guide-close]') || t.closest('[data-flow-guide-choose]')) { event.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function (event) {
    if (root.hidden || !guide) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    /* o foco não sai do guia */
    var items = Array.prototype.filter.call(guide.querySelectorAll(FOCUSABLE), function (el) { return el.offsetParent !== null; });
    if (!items.length) { event.preventDefault(); return; }
    var first = items[0], last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === guide)) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();


/* ENGRAM · página de avaliações (sections/engram-reviews-page): a resposta da Engram ([data-engram-reply], um <details>)
   fica aberta no desktop e fechada no telemóvel (desenho do José, 23 Out 2026). */
(function () {
  var replies = document.querySelectorAll("[data-engram-reply]");
  if (!replies.length) return;
  var desktop = window.matchMedia("(min-width: 990px)");
  function sync() { replies.forEach(function (d) { d.open = desktop.matches; }); }
  sync();
  if (desktop.addEventListener) desktop.addEventListener("change", sync);
})();
